/* eslint-disable */
import $ from 'jquery';
import BaseModule from './BaseModule';

export default class VehicleModelOverview extends BaseModule {
  constructor(el, factory) {
    super(el, factory, 'VehicleModelOverview');
    this.initPopup('.vmo-popup');
  }

  initPopup(items) {
    $(items).magnificPopup({
      delegate: 'a',
      type: 'image',
      tLoading: 'Loading image #%curr%...',
      mainClass: 'my-mfp-zoom-in',
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0,1] // Will preload 0 - before current, and 1 after the current image
      },
      image: {
        tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
      }
    });
  }
}
